import React, { ReactElement } from "react";
import { QueryOptionsItem } from "../FilterPanel/FilterPanel";
import { Autocomplete, TextField } from "@mui/material";
import "./EditModal.css";

export const textFieldsToSelect = (fields: string[]) => {
  return fields.map((field) => ({
    label: field,
    value: field,
    data: field,
  }));
};

export interface EditField {
  label: string;
  type: "text" | "number" | "select" | "switch";
  value?: any;
  options?: QueryOptionsItem[];
  onChange?: (value: any) => void;
}

interface EditModalProps {
  fields: EditField[];
  onSave: () => void;
  onClose: () => void;
}

const EditModal = React.memo<EditModalProps>(({ fields, onSave, onClose }) => {
  const styleFromItem = "form-item";
  const styleFromLabel = "form-label";
  const styleFromInput = "form-input";

  const handleModalClick = () => {
    onClose();
  };

  return (
    <>
      <div className="modal-overlay" onClick={handleModalClick}></div>
      <div className="modal">
        <div className="modal-title">编辑</div>
        {fields.map((field, index) => {
          let formItem: ReactElement | null = null;
          if (field.type === "select") {
            formItem = (
              <Autocomplete
                className={styleFromInput}
                id={`${field.label}-label`}
                limitTags={1}
                value={field.value}
                options={field.options || []}
                onChange={(e, value) => {
                  if (value) {
                    const data = value.data;
                    if (data && field.onChange) {
                      field.onChange(data);
                    }
                  }
                }}
                renderInput={(params) => <TextField {...params} label={""} />}
                getOptionKey={(option) => `${option.value}-${option.label}`}
              />
            );
          } else if (field.type === "text" || field.type === "number") {
            formItem = field.onChange ? (
              <input
                className={styleFromInput}
                type={field.type}
                value={field.value || ""}
                onChange={(e) =>
                  field.type === "text"
                    ? field.onChange?.(e.target.value)
                    : field.onChange?.(Number(e.target.value))
                }
              />
            ) : (
              <span>{field.value || ""}</span>
            );
          } else if (field.type === "switch") {
            formItem = (
              <input
                className={styleFromInput}
                type="checkbox"
                checked={field.value || false}
                onChange={(e) => field.onChange?.(e.target.checked)}
              />
            );
          }

          return (
            <div key={index} className={styleFromItem}>
              <label className={styleFromLabel}>{field.label}:</label>
              {formItem}
            </div>
          );
        })}
        <div className={styleFromItem}>
          <button className="form-button" onClick={onSave}>
            保存
          </button>
          <button className="form-button" onClick={onClose}>
            取消
          </button>
        </div>
      </div>
    </>
  );
});

export default EditModal;
